export default __webpack_public_path__ + "static/media/default.c921fe47ec5292655a4eb801ab3032da.png";